module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('AlphabetScroll', {
    attrs: {
      "alphabet": _vm.alphabet,
      "context": this,
      "scrollPos": _vm.scrollPos
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "offer-scroll animated fadeIn"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "letter-block",
      attrs: {
        "id": ("letter-" + (letter.letter))
      }
    }, _vm._l((_vm.rows[letter.letter]), function(row) {
      return (_vm.Helper.getOfferTitle(_vm.offers, row.id)) ? _c('StatisticTable', {
        key: row.id,
        attrs: {
          "title": ((_vm.Helper.getOfferTitle(_vm.offers, row.id)) + " (" + (row.id) + ")"),
          "headColumns": _vm.headColumns,
          "footColumns": _vm.footColumns[row.id],
          "rows": row.cells
        }
      }) : _vm._e()
    }))
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c08c3a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/conversions/Offer.vue
// module id = 512
// module chunks = 0